import PropTypes from 'prop-types';
// @mui
import { Grid } from '@mui/material';
import ItemGroupDevice from './itemGroupDevice';

// ----------------------------------------------------------------------

ListGroupDevice.propTypes = {
    products: PropTypes.array.isRequired,
};

export default function ListGroupDevice({ products, setData, functEdit, activeTab, ...other }) {
    return (
        <Grid container spacing={3} {...other}>
            {products
                .filter((ele) => {
                    if (activeTab == 0 && (ele.type == '1' || ele.type == '2')) {
                        return ele;
                    } else if (activeTab == 1 && (ele.type == '0' || ele.type == '2')) {
                        return ele;
                    }
                })
                .map((product) => (
                    <Grid key={product.id} item xs={6} sm={4} md={3} lg={2}>
                        <ItemGroupDevice product={product} setData={setData} />
                    </Grid>
                ))}
        </Grid>
    );
}
